"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    card: {
      width: "100%",
      borderRadius: 16,
      overflow: "hidden",
      border: "1px solid ".concat(theme.palette.background.border),
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    cardDestaque: {
      backgroundColor: "#E9F6FF"
    },
    actionArea: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      flexGrow: 1
    },
    mediaContainer: {
      position: "relative",
      width: "100%",
      paddingTop: "100%"
    },
    media: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover"
    },
    bannerAlternativo: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      padding: theme.spacing(1.5, 0.5, 0.5, 1.5),
      flexGrow: 1
    },
    titulo: _defineProperty({
      color: theme.palette.text.primary,
      fontSize: "16px",
      lineHeight: "1.25",
      fontWeight: 700,
      minHeight: 40,
      maxHeight: 40,
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginBottom: theme.spacing(1),
      wordBreak: "break-word"
    }, theme.breakpoints.down("sm"), {
      fontSize: 13,
      lineHeight: "1.25",
      minHeight: 36,
      maxHeight: 36
    }),
    subtitulo: _defineProperty({
      marginTop: theme.spacing(1),
      color: theme.palette.text.primary,
      fontSize: 12,
      lineHeight: "100%",
      fontWeight: 600
    }, theme.breakpoints.down("sm"), {
      fontSize: 12,
      lineHeight: "100%"
    }),
    descricao: _defineProperty({
      color: theme.palette.text.secondary,
      fontSize: 12,
      lineHeight: "140%",
      fontWeight: 400,
      marginTop: theme.spacing(1),
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere"
    }, theme.breakpoints.down("sm"), {
      fontSize: 11,
      lineHeight: "140%"
    }),
    actions: {
      marginTop: "auto",
      padding: theme.spacing(0.5, 1.5, 1, 1.5),
      justifyContent: "flex-end",
      minHeight: 24
    }
  };
});
var SttCard = function SttCard(_ref) {
  var titulo = _ref.titulo,
    descricao = _ref.descricao,
    subtitulo = _ref.subtitulo,
    banner = _ref.banner,
    altBanner = _ref.altBanner,
    onClick = _ref.onClick,
    acoes = _ref.acoes,
    children = _ref.children,
    className = _ref.className,
    maxWidth = _ref.maxWidth,
    destaque = _ref.destaque;
  var classes = useStyles();
  var classeCard = [classes.card, destaque ? classes.cardDestaque : "", className || ""].filter(Boolean).join(" ");
  var renderizarBanner = function renderizarBanner() {
    var imagemBanner = [banner, altBanner].find(function (valor) {
      return typeof valor === "string" && valor;
    });
    if (imagemBanner) {
      return /*#__PURE__*/_react["default"].createElement(_core.CardMedia, {
        className: classes.media,
        image: imagemBanner,
        title: titulo
      });
    }
    if ( /*#__PURE__*/_react["default"].isValidElement(altBanner)) {
      return /*#__PURE__*/_react["default"].createElement(_core.Box, {
        className: classes.bannerAlternativo
      }, altBanner);
    }
    return null;
  };
  var temBanner = Boolean(banner || altBanner);
  var conteudoCard = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, temBanner && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.mediaContainer
  }, renderizarBanner()), /*#__PURE__*/_react["default"].createElement(_core.CardContent, {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.titulo,
    title: titulo
  }, titulo), subtitulo && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.subtitulo
  }, subtitulo), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.descricao
  }, descricao), children));
  var handleCardClick = function handleCardClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    className: classeCard,
    style: maxWidth ? {
      maxWidth: maxWidth
    } : undefined
  }, onClick ? /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
    className: classes.actionArea,
    onClick: handleCardClick
  }, conteudoCard) : conteudoCard, acoes && /*#__PURE__*/_react["default"].createElement(_core.CardActions, {
    className: classes.actions
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, null, acoes)));
};
var _default = SttCard;
exports["default"] = _default;